export default __webpack_public_path__ + "src/assets/icn-network.223565106139b21b54d4b29222d99d39.svg";